// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseNotaryFactory instead of class inheritance

import { createBaseNotary, type IBaseNotary } from "../BaseNotaryFactory";
import type { OfficeFolderAnchor } from "le-coffre-resources/dist/Notary";
import type { IGetAnchorsParams } from "./OfficeFolderAnchors";
import {
	createGetMethod,
	createGetByUidMethod,
	createPostMethod,
	createDownloadMethod,
} from "./helpers/officeFolderAnchorsMethodsHelpers";

interface OfficeFolderAnchorsInstance {
	get(q?: IGetAnchorsParams): Promise<OfficeFolderAnchor[]>;
	getByUid(folderUid: string): Promise<OfficeFolderAnchor>;
	post(folderUid: string): Promise<OfficeFolderAnchor>;
	download(folderUid: string): Promise<Blob>;
}

// Module-level singleton instance
let instance: OfficeFolderAnchorsInstance | null = null;
let baseNotaryInstance: IBaseNotary | null = null;

function createOfficeFolderAnchors(): OfficeFolderAnchorsInstance {
	if (!baseNotaryInstance) {
		baseNotaryInstance = createBaseNotary();
	}

	const baseNotary = baseNotaryInstance;
	const foldersUrl = baseNotary.namespaceUrl.concat("/folders");

	return {
		get: createGetMethod(baseNotary),
		getByUid: createGetByUidMethod(baseNotary, foldersUrl),
		post: createPostMethod(baseNotary, foldersUrl),
		download: createDownloadMethod(baseNotary, foldersUrl),
	};
}

export function getOfficeFolderAnchorsInstance(): OfficeFolderAnchorsInstance {
	if (!instance) {
		instance = createOfficeFolderAnchors();
	}
	return instance;
}
